// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ActionLink from '../../../shared/components/action-link';
import LabeledNode from '../../../shared/components/labeled-node';
import LabeledString from '../../../shared/components/labeled-string';
import PartsClaim from '@deere/cps-it.warranty-model-factory/lib/claim-part';
import {buildDate} from '../../../shared/services/build-date';
import {translate} from '../../../shared/services/translation-service';

function handleActionLinkClick() {

    this.onActionLinkClick();

}

const CreateClaimDetails = props =>
    <div className='create-claim-details'>
        <LabeledNode
            className='claim-type'
            data={props.claimNumber ?
                <span>{props.claim.claimType.value}</span> :
                <ActionLink
                    isDisabled={false}
                    label={translate('PARTS')}
                    onClick={props::handleActionLinkClick}
                    type='button-link'
                />
            }
            label='CLAIM_TYPE'
        />
        <LabeledString
            className='claim-status'
            data={props.claim.claimStatus.value}
            label='STATUS'
        />
        <LabeledString
            className='created-date'
            data={buildDate(props.claim.recordInfo.createdDate)}
            label='CREATED'
        />
        <LabeledString
            className='modified-date'
            data={buildDate(props.claim.recordInfo.updatedDate)}
            label='MODIFIED'
        />
    </div>;

CreateClaimDetails.displayName = 'CreateClaimDetails';
CreateClaimDetails.propTypes = {
    claim: PropTypes.instanceOf(PartsClaim).isRequired,
    claimNumber: PropTypes.string,
    onActionLinkClick: PropTypes.func.isRequired
};

export default CreateClaimDetails;



// WEBPACK FOOTER //
// ./src/claim/parts/components/create-claim-details.js